import { render, staticRenderFns } from "./EditWebsiteMenu.vue?vue&type=template&id=8bbba16a&scoped=true&"
import script from "./EditWebsiteMenu.vue?vue&type=script&lang=js&"
export * from "./EditWebsiteMenu.vue?vue&type=script&lang=js&"
import style0 from "./EditWebsiteMenu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditWebsiteMenu.vue?vue&type=style&index=1&id=8bbba16a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbba16a",
  null
  
)

export default component.exports